@if (showNav()) {
<div class="side-nav">
    <div class="side-nav-top">
        <div class="side-nav-header">
            <img [src]="appLogoSrc" alt="Logo de la aplicación" />
        </div>
        @if (userResource.value(); as data) {
        <div class="description">
            <div class="line">
                <mat-icon fontSet="material-icons" class="avatar" aria-hidden="true">account_circle</mat-icon>
                <div class="data">
                    <div class="main">{{ data.user.firstName | titlecase }} {{ data.user.lastName | titlecase }}</div>
                    <div class="side"> @for (desc of userRolesDescriptions(); track $index) {
                        <span>
                            {{ desc | titlecase }}
                        </span>
                        }
                    </div>
                </div>
            </div>
        </div>
        }
        <div class="side-nav-links">
            @for (item of menu(); track item.label) {
            @if (item.children) {
            @let expanded = isExpanded(item.label);
            @let groupId = 'nav-group-' + $index;
            <button mat-button type="button" class="link group" [attr.aria-expanded]="expanded"
                [attr.aria-controls]="groupId" (click)="toggleGroup(item.label)">
                <mat-icon fontSet="material-icons" aria-hidden="true">{{ item.icon }}</mat-icon>
                <span>{{ item.label }}</span>
                <mat-icon fontSet="material-icons" class="chevron" iconPositionEnd aria-hidden="true">
                    {{ expanded ? 'expand_less' : 'expand_more' }}
                </mat-icon>
            </button>
            <div class="group-children" role="group" [id]="groupId" [attr.aria-label]="item.label" [hidden]="!expanded">
                @for (child of item.children; track child.label) {
                <button mat-button class="link child" [routerLink]="'/' + child.url" routerLinkActive="active-link"
                    ariaCurrentWhenActive="page" (click)="onMenuClick(child)">
                    @if (child.icon) {
                    <mat-icon fontSet="material-icons" aria-hidden="true">{{ child.icon }}</mat-icon>
                    }
                    <span>{{ child.label }}</span>
                </button>
                }
            </div>
            } @else {
            <button mat-button class="link" [routerLink]="'/' + item.url" routerLinkActive="active-link"
                ariaCurrentWhenActive="page" (click)="onMenuClick(item)">
                <mat-icon fontSet="material-icons" aria-hidden="true">{{ item.icon }}</mat-icon>
                <span>{{ item.label }}</span>
            </button>
            }
            }
        </div>
    </div>
    <div class="side-nav-bottom">
        <div class="side-nav-links">
            <button mat-button class="link warn" (click)="onLogout()">
                <mat-icon fontSet="material-icons" aria-hidden="true">logout</mat-icon>
                <span>Salir del Sistema</span>
            </button>
        </div>
        <div class="side-nav-footer">
            <img [src]="companyLogoSrc" alt="Logo de AGD" />
            <div class="data">
                <b class="main mono">Versión {{ version }}</b>
                <span class="side">{{ gTexts.copyrightShort }}</span>
            </div>
            <button mat-icon-button matTooltip="Ver cambios de esta versión" aria-label="Ver cambios de esta versión"
                (click)="viewChangeLog()">
                <mat-icon fontSet="material-icons" aria-hidden="true">info</mat-icon>
            </button>
        </div>
    </div>
</div>
}
